import { StyleSheet } from 'react-native'
import theme from '../../../theme'
const Styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        paddingVertical: 10,
    },
    categoryContainer: {
        flex: 1,
        borderRadius: 0,
        // borderWidth: 0.2,
        borderColor: theme.colors.lightGray,
        marginHorizontal: 0,
        marginBottom: 0,
        overflow: 'hidden',
    },
    brandContainer: {
        flex: 1,
        borderRadius: 25,
        marginHorizontal: 10,
        marginBottom: 10,
        overflow: 'hidden',
    },
    categoryContainerImageBackground: {
        flex: 1,
        padding: 10,
        aspectRatio: 25 / 9,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        justifyContent: 'center',
    },
    categoryContainerColorBackground: {
        flex: 1,
        padding: 10,
        backgroundColor: theme.colors.colorPrimary,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        justifyContent: 'center',
    },
    portfolioHeader: {
        paddingHorizontal: 10,
    },
    titleSection: {
        fontSize: 20,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginBottom: 5,
    },
    descriptionSection: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 10,
    },
    titleCategory: {
        fontSize: 20,
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'left',
        //textShadowColor: 'black', // Color del sombreado
        //textShadowOffset: { width: 2, height: 2 }, // Offset del sombreado
        //textShadowRadius: 5, // Radio del sombreado
    },
    descriptionCategory: {
        fontSize: 18,
        fontWeight: 'normal',
        color: 'white',
        textAlign: 'left',
        //textShadowColor: 'black', // Color del sombreado
        //textShadowOffset: { width: 2, height: 2 }, // Offset del sombreado
        //textShadowRadius: 5, // Radio del sombreado
    },
    spacer: {
        height: 8,
    },
})
export default Styles
